{% block coman_consent_manager_settings_icon %}
<div class="coman-consent-manager-settings-icon">
    <img
            alt="consentmanager Cookie Banner"
            class="coman-icon"
            :src="assetFilter('comanconsentmanager/img/plugin.png')"
    >
</div>
{% endblock %}

